import React from "react";
import HcsCaptionControl from "./hcs-captioncontrol";
import { TrackingTypes } from "../tools/tracking-base";
import HcsInfoButton from "./hcs-info-button";

export default class HcsDragItems extends HcsCaptionControl {
    constructor(props) {
        super(props);

        let self = this;

        this.activeItem = null;

        this.dragItemClassName = "hcs-ccao-drag-item-" + props.hcs.configurator;

        this.props.hcs.cad.dragItemStateChanged(data => { self.ccAOInteractionReset.call(self, data); });

        this.valueChanged = this.valueChanged.bind(this);
        this.buttonClicked = this.buttonClicked.bind(this);
        this.highlightElement = this.highlightElement.bind(this);

        this.listRef = React.createRef();
    }

    buttonClicked(event, item) {
        this.highlightElement(event.currentTarget, item);
    }

    highlightElement(element, dataItem) {
        let listContainer = this.listRef.current;

        if(listContainer) {
            var selElement = listContainer.querySelector(".hcs-selected");

            if(selElement) {
                selElement.classList.remove("hcs-selected");
            }

            if(element) {
                element.classList.add("hcs-selected");
            }

            this.activeItem = dataItem;
        }
    }

    ccAOInteractionReset(data) {
        const { hcs } = this.props;

        switch(data.eventType) {
            case "ccAO.anchorClick":
                if(this.activeItem) {
                    hcs.tracker.track(TrackingTypes.Placement, { "itemId": this.activeItem.ident });
                }

                this.highlightElement(null, null);
                break;

            case "ccAO.noIntersectClick":
            case "ccAO.resetInteraction":
                this.highlightElement(null, null);
                break;
        }
    }

    valueChanged(attrName, attrValue) {
        this.props.onConfig("setCfgValue", attrName, attrValue);
    }

    childClass() {
        return "hcs-dragitems";
    }

    initDragAndDrop() {
        const { hcs } = this.props;

        if(document.getElementsByClassName(this.dragItemClassName).length) {
            hcs.cad.ccAO.Snap.initDraggable({ draggableClass: this.dragItemClassName });
        }
    }

    componentDidUpdate() {
        this.initDragAndDrop();
    }

    componentDidMount() {
        this.initDragAndDrop();
    }

    render() {
        const { hcs, data } = this.props;

        return super.render(
            <ul ref={this.listRef}>
                {
                    data.values.filter((item) => { return item.info.visible; }).map(function(item, index) {
                        return (
                            <li key={`hcs-dragitem-${data.ident}-${index}`}>
                                <svg icon-id="dnd-cube" version="2.0">
                                    <use href="#dnd-cube"></use>
                                </svg>
                                <div
                                    title={item.info.trans}
                                    className={"hcs-dragitem " + this.dragItemClassName}
                                    data-target={`${item.data.CCAO_DATA}`}
                                    item-id={item.ident}
                                    onClick={(event) => { this.buttonClicked(event, item); }}
                                >
                                    <img src={hcs.api.getUrl("ConfigImage/icons", item.data.IMAGE)} />
                                    <span>{item.info.trans}</span>
                                </div>
								{item.data.TOOLTIP ?
									<HcsInfoButton contentHtml={item.data.TOOLTIP} /> : null
								}
                            </li>
                        );
                    }, this)
                }
            </ul>
        );
    }
}
